import { request } from '@/api/request';
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState, SimRemittancesState } from '@/util/interface';
import { CARD, SIM, STATUS_ERROR } from '@/constant';

const state: SimRemittancesState = {
  infoRemittancesFromCard: {},
  infoRemittancesFromSim: {},
  statusOfRemittancesToSim: {},
  remittancesFromCardErrors: {},
  remittancesFromCardErrorsCard: {},
  remittancesFromSimErrors: {},
  remittancesFromSimErrorsSim: {},
  confirmRemittancesToSim: {},
  confirmRemittancesToSimErrors: {},
  sim2simError: {},
};
const getters: GetterTree<SimRemittancesState, RootState> = {
  statusOfRemittancesToSim: (state) => state.statusOfRemittancesToSim,
  remittancesFromCard: (state) => state.infoRemittancesFromCard,
  remittancesFromSim: (state) => state.infoRemittancesFromSim,
  remittancesFromCardErrors: (state) => state.remittancesFromCardErrors,
  remittancesFromSimErrors: (state) => state.remittancesFromSimErrors,
  remittancesFromCardErrorsCard: (state) => state.remittancesFromCardErrorsCard,
  remittancesFromSimErrorsSim: (state) => state.remittancesFromSimErrorsSim,
  confirmRemittancesToSim: (state) => state.confirmRemittancesToSim, 
  confirmRemittancesToSimErrors: (state) => state.confirmRemittancesToSimErrors,
};

const actions: ActionTree<SimRemittancesState, RootState> = {
  initializationRemittances ({ commit }, data) {
    return request({ url: 'transfer/card2sim2/init',
      method: 'post',
      data }).then((res) => 
      res.data);
  },

  confirmRemittances ({ commit }, data) {
    return request({ url: 'transfer/card2sim2/confirm',
      method: 'post',
      data }).then((res) => {
      return res.data;
    }).catch((err) => {
      return err.response;
    });
  },

  remittancesStatus ({ commit }, id) {
    return request({ url: `status/${id}`,
      method: 'post' });
  },

  prevalidateRemittancesFromCard ({ commit }, data) {
    return request({ url: 'transfer/card2sim2/info',
      method: 'post' ,
      data }).then(res => {
      commit('setInfoRemittancesFromCard', {...data,
        ...res.data});
      commit('setRemittancesFromCardErrors', {});
      commit('setRemittancesFromCardErrorsCard', {}); 

      return res.data;
    }).catch((err) => {
      data.flag === CARD 
        ? commit('setRemittancesFromCardErrorsCard', err.response.data) 
        : commit('setRemittancesFromCardErrors', err.response.data);
      return err.response;
    });
  },

  prevalidateRemittancesFromSim ({ commit }, data) {
    return request({ url: 'transfer/info',
      method: 'post' ,
      data }).then(res => {
      commit('setInfoRemittancesFromSim', {...data,
        ...res.data});
      commit('setRemittancesFromSimErrors', {});
      commit('setRemittancesFromSimErrorsSim', {}); 
      return res.data;
    }).catch((err) => {
      data.flag === SIM
        ? commit('setRemittancesFromSimErrorsSim', err.response.data) 
        : commit('setRemittancesFromSimErrors', err.response.data);
      return err.response;
    });
  },

  sim2sim ({ commit }, data) { 
    commit('setLoading', true, { root: true });
    return request({ url: 'transfer/init',
      method: 'post' ,
      data }).catch((err) => {
      commit('setSim2simError', err.response.data);
      return err.response;
    }).finally(() => {
      commit('setLoading', false, { root: true });
    });
  },

  confirmRemittancesToSim ({ commit }, data) {
    commit('setLoading', true, { root: true });
    return request({ url: 'transfer/confirm',
      method: 'post' ,
      data })
      .then((res) => {
        res.data.status === STATUS_ERROR 
          ? commit('setConfirmRemittancesToSimErrors', res.data)
          : commit('setConfirmRemittancesToSim', res.data);
        return res.data;
      }).catch((err) => {
        commit('setConfirmRemittancesToSimErrors', err.response.data);
        return err.response;
      }).finally(() => {
        commit('setLoading', false, { root: true });
      });
  },

  resendOtp ({ commit }, payload){
    return request(
      { url: 'transfer/otp/resend',
        method: 'post' ,
        data: payload 
      });
  },
    
  getStatusOfRemittancesToSim ({ commit }, data) {
    commit('setLoading', true, { root: true });
    return request({ url: 'transfer/status',
      method: 'post' ,
      data })
      .then((res) => {
        commit('setStatusOfRemittancesToSim', res.data);
      })
      .finally(() => {
        commit('setLoading', false, { root: true });
      });
  }


};
const mutations: MutationTree<SimRemittancesState> = {
  setStatusOfRemittancesToSim(state, payload) {
    state.statusOfRemittancesToSim = payload;
  },

  setInfoRemittancesFromCard(state, payload) {
    state.infoRemittancesFromCard = payload;
  },

  setInfoRemittancesFromSim(state, payload) {
    state.infoRemittancesFromSim = payload;
  },
  
  setRemittancesFromCardErrors(state, payload) {
    state.remittancesFromCardErrors = payload;
  },
  
  setRemittancesFromSimErrors(state, payload) {
    state.remittancesFromSimErrors = payload;
  },
  setRemittancesFromCardErrorsCard(state, payload) {
    state.remittancesFromCardErrorsCard = payload;
  },
  
  setRemittancesFromSimErrorsSim(state, payload) {
    state.remittancesFromSimErrorsSim = payload;
  },
  setConfirmRemittancesToSim(state, payload) {
    state.confirmRemittancesToSim = payload;
  },
  setConfirmRemittancesToSimErrors(state, payload) {
    state.confirmRemittancesToSimErrors = payload;
  },
  setSim2simError(state, payload) {
    state.sim2simError = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
  